import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import { ArrowLeft, Clock } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Component displayed when a user navigates to a hidden page
 * Shows a themed message with customizable header, subtitle, and body
 */
const HiddenPageMessage = ({ 
  header = "Page Coming Soon",
  subtitle = "This page is currently under construction",
  body = "We're working on something exciting. Please check back soon.",
  showBackButton = true
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navigation />
      
      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-2xl mx-auto text-center">
          {/* Decorative Icon */}
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-[#00457f] to-[#003366] shadow-lg">
              <Clock className="w-10 h-10 text-yellow-400" />
            </div>
          </div>

          {/* Gold Accent Line */}
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-yellow-500"></div>
            <div className="w-2 h-2 bg-yellow-500 rotate-45"></div>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-yellow-500"></div>
          </div>

          {/* Header */}
          <h1 className="text-4xl md:text-5xl font-bold text-[#00457f] mb-4">
            {header}
          </h1>

          {/* Subtitle */}
          {subtitle && (
            <p className="text-xl md:text-2xl text-yellow-600 font-semibold mb-6">
              {subtitle}
            </p>
          )}

          {/* Body */}
          {body && (
            <p className="text-lg text-gray-600 mb-10 max-w-xl mx-auto leading-relaxed">
              {body}
            </p>
          )}

          {/* Back Button */}
          {showBackButton && (
            <Button
              onClick={() => navigate('/')}
              className="bg-[#00457f] hover:bg-[#003366] text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Return to Home
            </Button>
          )}

          {/* Decorative Bottom Element */}
          <div className="mt-16">
            <div className="inline-flex items-center gap-2 text-sm text-gray-400">
              <div className="w-8 h-px bg-gray-300"></div>
              <span>World Nuclear Congress</span>
              <div className="w-8 h-px bg-gray-300"></div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default HiddenPageMessage;
